<template>
  <div>
    <v-card class="mx-auto">
      <v-card-title>Pertinent Signs & Symptoms on Admission</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col v-for="(item, index) in symptoms" class="shrink my-0 py-0" cols="12" md="4" :key="item.id">
              <v-checkbox
                :label='item.name'
                :value="item.id"
                v-model="symptomCheckBox"
                hide-details
                @change="toggle => tick(item.id, toggle)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-if="isPain"
                label="Pain"
                placeholder="Remarks"
                outlined
                @keyup="includePainRemark"
                v-model="pain_remark"
                :rules="[v => !!v || 'Pain remarks is required']"
                required
              />
            </v-col>
            <v-col>
              <v-text-field
                v-if="isOther"
                label="Other"
                placeholder="Remarks"
                outlined
                @keyup="includeOtherRemark"
                v-model="other_remark"
                :rules="[v => !!v || 'Other remarks is required']"
                required
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="currentTab === 0"
          @click="backTab"
          color="info"
          class="mr-4">
          BACK
        </v-btn>
        <v-btn
          :disabled="!formData.sign_symptoms.length"
          @click="validate"
          color="success"
          class="mr-4">
          NEXT
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
            currentTab: Number,
            formData: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                modal: false,
                valid: false,
                painConfig: null,
                otherConfig: null,
                isPain: false,
                isOther: false,
                symptoms: [],
                other_remark: null,
                pain_remark: null,
                symptomCheckBox: [],
            }
        },

        methods: {
            validate() {
                if (this.$refs.form.validate() && Object.keys(this.formData.sign_symptoms).length !== 0) {
                    this.$bus.emit('nextTab', this.currentTab + 1);
                } else {
                    this.$snotify.error('Did you forget to check the box?', 'Oops!');
                }
            },
            reset() {
                this.$refs.form.reset()
            },
            backTab() {
                this.$bus.emit('nextTab', this.currentTab - 1);
            },

            onTick(id) {
                let pain = this.symptomCheckBox.includes(this.painConfig);
                let other = this.symptomCheckBox.includes(this.otherConfig);
                this.isPain = pain;
                this.isOther = other;
            },

            editField() {
                let vm = this;
                _.forEach(this.formData.sign_symptoms, function (value) {
                    vm.symptomCheckBox.push(value.symptom_id);
                    if (value.pain_remark) {
                        vm.isPain = !vm.isPain;
                        vm.pain_remark = value.pain_remark;
                    }
                    if (value.other_remark) {
                        vm.isOther = !vm.isOther;
                        vm.other_remark = value.other_remark;
                    }
                });
            },

            tick(key, toggle) {
                switch (key) {
                    case this.painConfig:
                        this.isPain = !this.isPain;
                        break;
                    case this.otherConfig:
                        this.isOther = !this.isOther;
                        break;
                    default:
                    // code block
                }

                let symptoms = this.formData.sign_symptoms;
                if (toggle.includes(key)) {
                    symptoms.push({
                        symptom_id: key,
                        other_remark: key === this.otherConfig ? this.other_remark : null,
                        pain_remark: key === this.painConfig ? this.pain_remark : null
                    });
                } else {
                    let index = symptoms.findIndex(symptoms => symptoms.symptom_id === key);
                    symptoms.splice(index, 1);
                }
            },

            includeOtherRemark() {
                let symptoms = this.formData.sign_symptoms;
                let index = symptoms.findIndex(symptoms => symptoms.symptom_id === this.otherConfig);
                symptoms.splice(index, 1);
                symptoms.push({
                    symptom_id: this.otherConfig,
                    other_remark: this.other_remark,
                    pain_remark: null
                });
            },

            includePainRemark() {
                let symptoms = this.formData.sign_symptoms;
                let index = symptoms.findIndex(symptoms => symptoms.symptom_id === this.painConfig);
                symptoms.splice(index, 1);
                symptoms.push({
                    symptom_id: this.painConfig,
                    other_remark: null,
                    pain_remark: this.pain_remark
                });
            },

            getOtherConfig() {
                this.axios.get('config-other', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    return this.otherConfig = response.data;
                }).catch((error) => {
                    console.error(error);
                });
            },

            getPainConfig() {
                this.axios.get('config-pain', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    return this.painConfig = response.data;
                }).catch((error) => {
                    console.error(error);
                });
            },

            getSignSymptoms() {
                this.axios.get('sign-symptoms-lib', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    this.symptoms = response.data;
                }).catch((error) => {
                    console.error(error);
                });
            }
        },

        mounted() {
            this.getSignSymptoms();
            this.getOtherConfig();
            this.getPainConfig();
            this.editField();
        },
    }
</script>

<style scoped>

</style>
